const Footer = () => {
     return (
          <div class="container">
               <footer class="my-4 py-3">
                    <ul class="border-bottom justify-content-center mb-3 nav pb-3">
                         <li class="nav-item">
                              <a class="nav-link px-2 text-body-secondary" href="#">
                                   Home
                              </a>
                         </li>
                         <li class="nav-item">
                              <a class="nav-link px-2 text-body-secondary" href="#">
                                   Sobre
                              </a>
                         </li>
                         <li class="nav-item">
                              <a class="nav-link px-2 text-body-secondary" href="#">
                                   Contato
                              </a>
                         </li>
                         <li class="nav-item">
                              <a class="nav-link px-2 text-body-secondary" href="#">
                                   Solu&ccedil;&atilde;o Madya
                              </a>
                         </li>
                    </ul>
                    <p class="text-body-secondary text-center">
                         2024 &copy; Infocerta Inform&aacute;tica LTDA
                    </p>
               </footer>
          </div>
     );
}

export default Footer;